import React, { useState, useEffect } from 'react';
import Panel from './Panel';
import useGlobal from '../../store';
import Spinner from '../General/Spinner';
import AddGiftlistForm from '../Forms/AddGiftlistForm';

const AddGiftlist = (props) => {

    const [isLoading, setIsLoading] = useState(false);

    const [panel, uiActions] = useGlobal(
        state => state.ui.sidepanel,
        actions => actions.uiActions
    );

    const [response, userActions] = useGlobal(
        state => state.response,
        actions => actions.userActions
    );

    const closePanel = () => {
        uiActions.closeSidePanel();
    }

    const handleAddGiftlistFormSubmit = (formData) => {
        console.log('ADDING NEW GIFTLIST....', formData);
        setIsLoading(true);
        userActions.updateItem(formData);
    }

    useEffect(() => {
        if(!response || response.type !=="addgiftlist" || panel.name !== "addgiftlist") {
            return;
        }
        console.log('GOT A RESPONSE ADD GIFT LIST!', response);
        setIsLoading(false);
        uiActions.closeSidePanel();
        uiActions.clearResponse();
    }, [response, uiActions, panel.name]);

    
    return (
        <Panel open={props.open && panel.name === "addgiftlist"}>
            {props.name === "addgiftlist" ?
                <>
                <div className="kt-offcanvas-panel__nav bg-white" kt-hidden-height="77">
                    <h3>Create New Gift List</h3>
                    <button className="kt-offcanvas-panel__close" id="kt_quick_panel_close_btn" onClick={() => closePanel()}><i className="flaticon2-delete"></i></button>
                </div>
                
                <div className="kt-offcanvas-panel__body">
                    <div className="tab-content">
                        <div className="tab-pane fade show kt-offcanvas-panel__content kt-scroll active ps ps--active-y" id="kt_quick_panel_tab_notifications" role="tabpanel" >

                            {isLoading 
                                ? <Spinner></Spinner> 
                                : <AddGiftlistForm submitForm={handleAddGiftlistFormSubmit}></AddGiftlistForm> }
                        
                        </div>
                    </div>
                </div>
                </> : <></>}
        </Panel>

    );
}

export default AddGiftlist;